import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import "./Envios.css";

function Envios() {
  const pasos = [
    {
      id: 1,
      icono: "bi-search",
      titulo: "Busca tu producto",
      descripcion:
        "Explora nuestro catálogo y encuentra el repuesto, accesorio o producto que necesitas.",
    },
    {
      id: 2,
      icono: "bi-chat-dots",
      titulo: "Confirma disponibilidad",
      descripcion:
        "Comunícate con nuestro equipo para confirmar existencia, precio y cantidad disponible.",
    },
    {
      id: 3,
      icono: "bi-receipt",
      titulo: "Confirma tu pedido",
      descripcion:
        "Verificamos los datos del pedido y la información necesaria para coordinar el despacho.",
    },
    {
      id: 4,
      icono: "bi-box-seam",
      titulo: "Preparamos el envío",
      descripcion:
        "El pedido se revisa y prepara cuidadosamente antes de ser entregado al transporte.",
    },
    {
      id: 5,
      icono: "bi-truck",
      titulo: "Despachamos tu compra",
      descripcion:
        "Coordinamos la entrega del pedido mediante la opción de transporte disponible para tu destino.",
    },
  ];

  const zonas = [
    {
      id: 1,
      icono: "bi-water",
      titulo: "Costa",
      descripcion:
        "Consulta opciones de envío disponibles para ciudades y cantones de la región Costa.",
    },
    {
      id: 2,
      icono: "bi-mountains",
      titulo: "Sierra",
      descripcion:
        "Coordinamos el despacho de pedidos según la cobertura disponible hacia la región Sierra.",
    },
    {
      id: 3,
      icono: "bi-tree",
      titulo: "Amazonía",
      descripcion:
        "Consulta con nuestro equipo las alternativas de envío disponibles para tu localidad.",
    },
    {
      id: 4,
      icono: "bi-compass",
      titulo: "Región Insular",
      descripcion:
        "La disponibilidad de envío puede variar según transporte, destino y características del pedido.",
    },
  ];

  const recomendaciones = [
    "Confirma siempre la disponibilidad del producto antes de realizar el pago.",
    "Verifica que tu nombre, número de teléfono, ciudad y dirección estén correctamente escritos.",
    "Consulta previamente el valor y la modalidad de transporte disponible para tu destino.",
    "Conserva la información de tu pedido hasta confirmar la recepción.",
  ];

  return (
    <div className="envios-page">
      <Navbar />

      <main>
        {/* =====================================================
            HERO
        ===================================================== */}
        <section className="envios-hero">
          <div className="envios-container">
            <div className="envios-hero-card">
              <div className="envios-hero-content">
                <span className="envios-kicker">
                  DESPACHOS Y ENTREGAS
                </span>

                <h1>Envíos de tus productos</h1>

                <p>
                  Consulta las opciones disponibles para recibir tus repuestos y
                  productos. Nuestro equipo te ayuda a coordinar cada paso de tu
                  pedido de forma clara y sencilla.
                </p>

                <div className="envios-hero-actions">
                  <a
                    href="https://wa.link/8proeq"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="envios-primary-button"
                  >
                    <i className="bi bi-whatsapp"></i>
                    Consultar envío
                  </a>

                  <a
                    href="/industrialr"
                    className="envios-secondary-button"
                  >
                    <i className="bi bi-grid"></i>
                    Ver catálogo
                  </a>
                </div>
              </div>

              <div className="envios-hero-icon">
                <i className="bi bi-truck"></i>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            PROCESO
        ===================================================== */}
        <section className="envios-section envios-process-section">
          <div className="envios-container">
            <div className="envios-section-header">
              <div>
                <span className="envios-section-kicker">
                  CÓMO FUNCIONA
                </span>

                <h2>Proceso de envío</h2>

                <p>
                  Desde la consulta del producto hasta el despacho de tu pedido,
                  estos son los pasos principales.
                </p>
              </div>

              <div className="envios-header-line"></div>
            </div>

            <div className="envios-process-grid">
              {pasos.map((paso, index) => (
                <article className="envios-process-card" key={paso.id}>
                  <div className="envios-process-top">
                    <span className="envios-step-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>

                    <span className="envios-process-icon">
                      <i className={`bi ${paso.icono}`}></i>
                    </span>
                  </div>

                  <h3>{paso.titulo}</h3>

                  <p>{paso.descripcion}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            COBERTURA
        ===================================================== */}
        <section className="envios-section envios-coverage-section">
          <div className="envios-container">
            <div className="envios-section-header">
              <div>
                <span className="envios-section-kicker">
                  DESTINOS
                </span>

                <h2>Consulta cobertura para tu ciudad</h2>

                <p>
                  La disponibilidad del envío depende del destino, transporte y
                  características del pedido.
                </p>
              </div>

              <div className="envios-header-line"></div>
            </div>

            <div className="envios-coverage-grid">
              {zonas.map((zona) => (
                <article className="envios-coverage-card" key={zona.id}>
                  <span className="envios-coverage-icon">
                    <i className={`bi ${zona.icono}`}></i>
                  </span>

                  <div>
                    <h3>{zona.titulo}</h3>
                    <p>{zona.descripcion}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* =====================================================
            INFORMACIÓN IMPORTANTE
        ===================================================== */}
        <section className="envios-section envios-info-section">
          <div className="envios-container">
            <div className="envios-info-layout">
              <div className="envios-info-card">
                <div className="envios-info-card-header">
                  <span className="envios-info-icon">
                    <i className="bi bi-info-circle"></i>
                  </span>

                  <div>
                    <span>ANTES DEL DESPACHO</span>
                    <h2>Información importante</h2>
                  </div>
                </div>

                <div className="envios-info-list">
                  {recomendaciones.map((item, index) => (
                    <div className="envios-info-item" key={index}>
                      <span>
                        <i className="bi bi-check-lg"></i>
                      </span>

                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <aside className="envios-help-card">
                <span className="envios-help-icon">
                  <i className="bi bi-headset"></i>
                </span>

                <span className="envios-help-kicker">
                  ATENCIÓN PERSONALIZADA
                </span>

                <h3>¿Quieres consultar un envío?</h3>

                <p>
                  Escríbenos por WhatsApp y envíanos el nombre del producto y tu
                  ciudad para revisar las opciones disponibles.
                </p>

                <a
                  href="https://wa.link/8proeq"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-whatsapp"></i>
                  Hablar con nosotros
                </a>
              </aside>
            </div>
          </div>
        </section>

        {/* =====================================================
            CTA FINAL
        ===================================================== */}
        <section className="envios-final-section">
          <div className="envios-container">
            <div className="envios-final-card">
              <div>
                <span>G&J FRÍO INDUSTRIAL Y DOMÉSTICO</span>

                <h2>Encuentra lo que necesitas y consulta tu envío</h2>

                <p>
                  Nuestro equipo puede ayudarte con disponibilidad, pedido y
                  coordinación del despacho.
                </p>
              </div>

              <a
                href="https://wa.link/8proeq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp"></i>
                Consultar ahora
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default Envios;
